import TimeSheetTabContent from './TimeSheetTabContent';

const CheckedContent = () => (
  <TimeSheetTabContent status="3" emptyStateType="time_sheet_checked" showStatusColumn />
);

export default CheckedContent;
